import { render, staticRenderFns } from "./NvBottomMenu.vue?vue&type=template&id=c140d190&scoped=true&"
import script from "./NvBottomMenu.vue?vue&type=script&lang=js&"
export * from "./NvBottomMenu.vue?vue&type=script&lang=js&"
import style0 from "./NvBottomMenu.vue?vue&type=style&index=0&id=c140d190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c140d190",
  null
  
)

export default component.exports